<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            <span v-if="subscription.id">Редактирование абонемента</span>
                            <span v-else>Добавление абонемента</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Наименование</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.subscription.name.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.subscription.name.$error === true || forms.subscription.errors.name" class="error">
                                        {{ this.forms.subscription.errors.name ? this.forms.subscription.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Цена</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.subscription.price.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="glyphicon glyphicon-rub"></i></label>
                                    </label>
                                    <div v-if="$v.subscription.price.$error === true || forms.subscription.errors.price" class="error">
                                        {{ this.forms.subscription.errors.price ? this.forms.subscription.errors.price.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Количество занятий</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.subscription.count.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="glyphicon glyphicon-fire"></i></label>
                                    </label>
                                    <div v-if="$v.subscription.count.$error === true || forms.subscription.errors.count" class="error">
                                        {{ this.forms.subscription.errors.count ? this.forms.subscription.errors.count.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Срок действия</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.subscription.days.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa  fa-calendar"></i></label>
                                    </label>
                                    <div v-if="$v.subscription.days.$error === true || forms.subscription.errors.days" class="error">
                                        {{ this.forms.subscription.errors.days ? this.forms.subscription.errors.days.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Ограничение по времени в будни</label>
                                    <label class="field prepend-icon">
                                        <input type="time" v-model="$v.subscription.maxTime.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="glyphicon glyphicon-time"></i></label>
                                    </label>
                                    <div v-if="$v.subscription.maxTime.$error === true || forms.subscription.errors.max_time" class="error">
                                        {{ this.forms.subscription.errors.max_time ? this.forms.subscription.errors.max_time.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Ограничение по времени в выходные</label>
                                    <label class="field prepend-icon">
                                        <input type="time" v-model="$v.subscription.maxTimeWeekend.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="glyphicon glyphicon-time"></i></label>
                                    </label>
                                    <div v-if="$v.subscription.maxTimeWeekend.$error === true || forms.subscription.errors.max_time_weekend" class="error">
                                        {{ this.forms.subscription.errors.max_time_weekend ? this.forms.subscription.errors.max_time_weekend.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-user-status" v-model="$v.subscription.canSale.$model" value="10">
                                        <label for="form-user-status" data-on="Да" data-off="Нет"></label>
                                        <span>Учитывается при скидке</span>
                                    </label>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-status" v-model="$v.subscription.status.$model" value="1">
                                        <label for="form-status" data-on="Да" data-off="Нет"></label>
                                        <span>Активен</span>
                                    </label>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.subscription.comment.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.subscription.isSubmitting">
                                <span v-if="subscription.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Subscription from "../../models/Subscription";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {

            if (to.params.id) {
                try {
                    const subscription = await Subscription.get(to.params.id);
                    next(async component => {
                        component.subscription = subscription;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                });
            }
        },
        data() {
            return {
                subscription: new Subscription(),
                forms: {
                    subscription: {
                        isSubmitting: false,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            subscription: {
                name: {required},
                price: {},
                days: {},
                count: {},
                canSale: {},
                comment: {},
                maxTime: {},
                status: {},
                maxTimeWeekend: {},
            },
        },
        methods: {
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.subscription.isSubmitting = true;
                this.forms.subscription.errors = {};

                if (this.subscription.id) {

                    try {
                        await this.subscription.update();
                    } catch (error) {
                        this.forms.subscription.errors = error.errors;
                    }

                } else {

                    try {
                        await this.subscription.add();

                        await this.$router.push({name: 'subscriptions-edit', params: {id: this.subscription.id}});
                    } catch (error) {
                        this.forms.subscription.errors = error.errors;
                    }

                }

                this.forms.subscription.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Абонементы - ' + (this.subscription.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
